import InteractionOptionsReducer from "@common/redux/reducers/InteractionOptionsReducer";
import BaseAction from "@common/redux/actions/BaseAction";

class InteractionOptionsAction extends BaseAction {
  setLoadingOptions = async (value) =>
    await this.dispatch({ loadingOptions: value });
}

const action = new InteractionOptionsAction(InteractionOptionsReducer);

export default action;
